module.exports = __webpack_public_path__ + "img/71.8cb0e9ab.jpg";